import axios from 'axios';
import keys, { backendUrl } from 'config';
import Pusher from 'pusher-js';

const pusher = new Pusher(keys.ENVIRONMENT === 'production' ? '073f814043d47e847056' : '0581d1392666af2ddd38', {
    cluster: 'eu',
    channelAuthorization: {
        customHandler: (channel, callback: any) => {
            axios
                .post(
                    backendUrl('/api/pusher/auth'),
                    {
                        socket_id: channel.socketId,
                        channel_name: channel.channelName,
                    },
                    { withCredentials: true },
                )
                .then((response) => {
                    callback(false, response.data);
                })
                .catch((error) => {
                    callback(true, error.response ? error.response.data : error.message);
                });
        },
    },
});

export default pusher;
